
$(document).ready(function () {

    // Reg lookup
    $( '.component-vehicle-lookup .dropdown-menu .dropdown-item' ).on( 'click', function (event) {

        event.preventDefault();

        var country = $( this ).data( 'value' );

        // Add the country code to the hidden input js_reg_lookup_country
        $( '#js_reg_lookup_country' ).val( country );

        $( '.component-vehicle-lookup .dropdown-toggle' ).text( country );

        // Hide and show the key number link
        if (country == "DE") {
            $('.js-key_number').show();
            $('.js-reglookup').hide();
            $('.js-reglookup').prop('required',false);
        } else {
            $('.js-key_number').hide();
            $('.js-reglookup').show();
            $('.js-reglookup').prop('required',true);
        }
    });

    $('.js-btn-unknownreg').on('click', function() {
        $(this).toggleClass('active');
        var panel = $('.vehicle-lookup-accordion');
        if($(panel).css('max-height') != '0px') {
            $(panel).css('max-height', '0px');
        } else {
            $(panel).css('max-height', $(panel).prop('scrollHeight') + 'px');
            var anchor = document.querySelector('#open-dropdowns');
            anchor.scrollIntoView({
                behavior: 'smooth', // Defines the transition animation. default: auto
            });
        }
    });

    if($('.js-btn-unknownreg').hasClass('active')) {
        var panel = $('.vehicle-lookup-accordion');
        if($(panel).css('max-height') != '0px') {
            $(panel).css('max-height', '0px');
        } else {
            $(panel).css('max-height', $(panel).prop('scrollHeight') + 'px');
        }
    }

    // we need to get current locale
    var segments = $(location).attr('pathname').split('/');
    var locale_segment = '/' + segments[1] + '/';

    $('.vehicle-make').on('change', function () {
        var vehicle_make = $(this);
        $('.vehicle-make').not(this).val(vehicle_make.val());
        $('.vehicle-make').not(this).trigger("chosen:updated");
        $.ajax({
            method: "POST",
            url: locale_segment + 'b2b/vehicle/years',
            data: {
                make_id: vehicle_make.val()
            },
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            },
            success: function (data) {
                var modelTrans = $('.vehicle-model').data("placeholder");
                $('.vehicle-model').empty().append($("<option>" + modelTrans + "</option>").attr('value',''));
                $('.vehicle-model').trigger("chosen:updated");
                var yearTrans = $('.vehicle-year').data("placeholder");
                $('.vehicle-year').empty().append($("<option>" + yearTrans + "</option>").attr('value',''));
                $.each(data, function (idx, year) {
                    $('.vehicle-year').append($("<option></option>").attr("value", year).text(year));
                });
                $('.vehicle-year').trigger("chosen:updated");
            },
            dataType: "json"
        });
    });

    $('.vehicle-year').on('change', function () {
        var vehicle_year = $(this);
        $('.vehicle-year').not(this).val(vehicle_year.val());
        $('.vehicle-year').not(this).trigger("chosen:updated");
        var vehicle_make = vehicle_year.closest('form').find('.vehicle-make');
        $.ajax({
            method: "POST",
            url: locale_segment + 'b2b/vehicle/models',
            data: {
                make_id: vehicle_make.val(),
                year: vehicle_year.val(),
            },
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            },
            success: function (data) {
                var modelTrans = $('.vehicle-model').data("placeholder");
                $('.vehicle-model').empty().append($("<option>" + modelTrans + "</option>").attr('value',''));
                $.each(data, function(index, modelGroup) {
                    $('.vehicle-model').append($("<optgroup></option>").attr("label", index).addClass('vehicle-group-title'));
                    $.each(modelGroup, function(id, model) {
                        $('.vehicle-model').append($("<option></option>").attr("value", id).text(model));
                    });
                });
                $('.vehicle-model').trigger("chosen:updated");

            },
            dataType: "json"
        });
    });

    $('.vehicle-model').on('change', function () {
        var vehicle_model = $(this);
        $('.vehicle-variant').not(this).val($(this).val());
        $('.vehicle-variant').not(this).trigger("chosen:updated");

        $.ajax({
            method: "POST",
            url: locale_segment + 'b2b/vehicle/vehicles',
            data: {
                model_id: vehicle_model.val()
            },
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            },
            success: function (data) {
                var variantTrans = $('.vehicle-variant').data("placeholder");
                $('.vehicle-variant').empty().append($("<option>" + variantTrans + "</option>").attr('value',''));

                if (!$('.vehicle-variant').prop('required')) {
                    var variantUnknown = $('.vehicle-variant').data("variant-unknown");
                    $('.vehicle-variant').append($("<option>" + variantUnknown + "</option>").attr('value',''));
                }

                $.each(data, function (id, variant) {
                    $('.vehicle-variant').append($("<option></option>").attr("value", id).text(variant));
                });
                $('.vehicle-variant').trigger("chosen:updated");
            },
            dataType: "json"
        });
    });

    if($('.vehicle-make').val() != '') {
        $('.vehicle-make').trigger('change');
    }

    // Order by select change (products)
    $(document).on('change', '#order', function () {
        window.location = $('option:selected', this).attr('data-url');
    });

    $('.js-key_number_button').on('click', function () {
        $('#key_number_modal').modal('show');
    });
});
